export enum CompanyTypes {
  SISTER = 'SISTER',
  ASSAY = 'ASSAY',
}
